import { Col, Container, Row } from "design-react-kit";

import PropTypes from "prop-types";
import React from "react";
import ShareThis from "./ShareThis";

const SectionTitle = ({ sharethis = false }) => {
  return (
    <Container tag="div">
      <Row tag="div">
        <Col tag="div" className="px-4"></Col>
        {sharethis && (
          <Col lg={4} className="px-4 sharethis-section-title">
            <ShareThis label={false} />
          </Col>
        )}
      </Row>
    </Container>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SectionTitle;
